import { useEffect, useState } from "react";
import { AppError } from "../../../../stores/models/errors/AppError";
import { IOrganizationSignUpFlowValues } from "../_interfaces/IOrganizationSignUpFlowValues";
import { MainOrganizationDetailsStepValues } from "../_interfaces/IOrganizationSignUpStepTypeValues";
import { IOrganizationPrimaryDetailsFormValues } from "../../../authentication/_interfaces/IOrganizationPrimaryDetailsFormValues";
import { OrganizationPrimaryDetailsValidation } from "../validation/OrganizationPrimaryDetailsValidation";

export function useMainOrganizationDetailsController(
    values: MainOrganizationDetailsStepValues,
    allValues: IOrganizationSignUpFlowValues,
    update: (patch: Partial<MainOrganizationDetailsStepValues>) => void,
    onSuccess: (override?: Partial<MainOrganizationDetailsStepValues>) => void
): {
    values: IOrganizationPrimaryDetailsFormValues,
    onChange: (patch: Partial<IOrganizationPrimaryDetailsFormValues>) => void,
    onSubmit: (override?: Partial<MainOrganizationDetailsStepValues>) => void,
    isSubmitting: boolean,
    error: string | undefined,
    fieldErrors: Partial<Record<keyof IOrganizationPrimaryDetailsFormValues, string>>
} {
    const [error, setError] = useState<string>();
    const [fieldErrors, setFieldErrors] = useState<Partial<Record<keyof IOrganizationPrimaryDetailsFormValues, string>>>({});
    const [isSubmitting, setSubmitting] = useState(false);
    const [validationRun, setValidationRun] = useState(false);

    useEffect(() => {
        update({ backClicked: false })
    }, [])

    const validate = (override?: Partial<MainOrganizationDetailsStepValues>) => {
        return OrganizationPrimaryDetailsValidation({ ...values, ...override });
    }

    useEffect(() => {
        if (validationRun) {
            const errors = validate().errors;
            setFieldErrors(errors);
        }
    }, [values.organizationName, values.ein, values.signUpCode, validationRun])

    const isValidSubmission = (override?: Partial<MainOrganizationDetailsStepValues>) => {
        return validate(override).valid;
    }

    const submit = async (override?: Partial<MainOrganizationDetailsStepValues>) => {
        setSubmitting(true);
        setError(undefined);
        setValidationRun(true);

        try {
            if (isValidSubmission(override)) {
                update({ ...override });
                onSuccess(override);
            }
        } catch (err) {
            if (err instanceof AppError) {
                switch (err.code) {
                    default:
                        setError(err.message);
                }
            } else {
                setError("An unknown error occurred.");
            }
        } finally {
            setSubmitting(false);
        }
    };

    return {
        values,
        onChange: update,
        onSubmit: submit,
        isSubmitting,
        error,
        fieldErrors
    };
}
